import $ from 'jquery';

let timeout;

const customerProductNote = $( '.customer-note' ),
	customerProductNoteInput = customerProductNote.find( '.customer-note__input' );

customerProductNoteInput.on( 'keyup', function ( e ) {
	const pshNumber = $( e.target ).data( 'psh-number' );
	const text = $( e.target ).val();

	clearTimeout(timeout);
	timeout = setTimeout(function (){
		updateEgosNote( customerProductNote, pshNumber, text);
	}, 600);
} );

const updateEgosNote = (customerProductNote, pshNumber, text) => {
	customerProductNote.addClass( 'customer-note--loading' ).removeClass( 'customer-note--error' ).removeClass( 'customer-note--success' );

	$.ajax( {
		type: "POST",
		url: psh_vars.rest_route.psh_customer_note,
		data: {
			psh_number: pshNumber,
			text: text
		},
		complete: function () {
			customerProductNote.removeClass( 'customer-note--loading' );
		},
		success: function () {
			customerProductNote.addClass( 'customer-note--success' ).removeClass( 'customer-note--error' );
		},
		error: function () {
			customerProductNote.addClass( 'customer-note--error' ).removeClass( 'customer-note--success' );
		}
	} );
}

const getCustomerNoteList = () => {
	let customerProductNote = document.querySelector( '.customer-note__input' );

	if ( typeof customerProductNote === 'undefined' || customerProductNote === null ) {
		return;
	}

	let pshNumber = customerProductNote.dataset.pshNumber ?? '';

	fetch( psh_vars.rest_route.psh_customer_list_note, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify( {
			psh_number: pshNumber,
		} ),
	} )
		.then( response => {
			if ( !response.ok ) {
				throw new Error( 'Network response was not ok' );
			}
			return response.json();
		} )
		.then( responseData => {
			customerProductNote.value = responseData.customer_note;
		} )
		.catch( error => {
			console.error( 'Error:', error );
		} );
}

if ( document.readyState !== 'loading' ) {
	getCustomerNoteList();
} else {
	document.addEventListener( 'DOMContentLoaded', function () {
		getCustomerNoteList();
	} );
}
